import { Link } from "react-router-dom";
import { Magnet, ExternalLink } from "lucide-react";

const BlogFooter = () => {
  return (
    <footer 
      className="border-t border-border/40 bg-muted/30 py-12"
      role="contentinfo"
      aria-label="Rodapé do site"
    >
      <div className="container mx-auto px-4">
        <div className="grid gap-8 md:grid-cols-4">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link 
              to="/" 
              className="flex items-center gap-2 mb-4"
              aria-label="Ir para página inicial"
            >
              <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-gradient-to-br from-primary to-primary/60">
                <Magnet className="h-4 w-4 text-primary-foreground" aria-hidden="true" />
              </div>
              <span className="text-lg font-semibold">Magnet Link</span>
            </Link>
            <p className="text-sm text-muted-foreground max-w-sm">
              Crie formulários inteligentes com IA que geram PDFs automáticos e capturam leads qualificados para o seu negócio.
            </p>
          </div>

          {/* Links */}
          <nav aria-label="Links úteis">
            <h3 className="font-semibold mb-4">Links Úteis</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link 
                  to="/" 
                  className="hover:text-foreground transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded-sm"
                >
                  Início
                </Link>
              </li>
              <li>
                <Link 
                  to="/blog" 
                  className="hover:text-foreground transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded-sm"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link 
                  to="/auth?mode=signup" 
                  className="hover:text-foreground transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded-sm"
                >
                  Criar Conta
                </Link>
              </li>
            </ul>
          </nav>

          {/* Legal */}
          <nav aria-label="Informações legais">
            <h3 className="font-semibold mb-4">Legal</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <span className="text-muted-foreground/60">Termos de Uso</span>
              </li>
              <li>
                <span className="text-muted-foreground/60">Privacidade</span>
              </li>
            </ul>
          </nav>
        </div>

        <div className="mt-8 pt-8 border-t border-border/40 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-muted-foreground">
          <p>© {new Date().getFullYear()} Magnet Link. Todos os direitos reservados.</p>
          <a
            href="https://shinier.com.br"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 hover:underline focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded-sm"
            aria-label="Visitar site da Shinier, empresa aceleradora (abre em nova aba)"
          >
            Empresa Acelerada pela <span className="text-primary font-bold">Shinier</span>
            <ExternalLink className="w-4 h-4" aria-hidden="true" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default BlogFooter;
